<template>
  <div class="story">
    <sheet>
      <loading v-if="isLoading"></loading>
      <template v-else>
      <h3 class="story-title">{{ articleData.title }}</h3>
      <div class="time-type">
        <p class="time-type__time">{{ articleData.formatPublished }}</p>
        <!-- <p class="time-type__type">最新活動訊息</p> -->
      </div>
      <divide dashed mt="20" mb="55" />

      <div class="video-container">

      <iframe
        width="560"
        height="315"
        :src="videoSrc"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      </div>

      <div class="article-content" v-html="articleData.content"></div>

      <divide dashed mt="110" mb="30" />
      <more-media :title="`更多${articleData.category?.name || ''}`" />
      </template>
    </sheet>
  </div>
</template>

<script>
import { defineComponent, watch, ref } from 'vue';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';
import Divide from '@/components/Global/Divide.vue';
import MoreMedia from '@/components/Resources/MoreMedia.vue';
import { getIndexArticlesAPI } from '@/api/articles';
import useRequest from '@/hooks/useRequest';
import { useExtraBreadcrumbStore } from '@/store/extraBreadcrumb';

export default defineComponent({
  name: 'Announcement',
  components: {
    Divide,
    MoreMedia,
  },
  setup() {
    const route = useRoute();
    const articleData = ref({});
    const videoSrc = ref('');
    const extraBreadcrumbStore = useExtraBreadcrumbStore();

    const { response, request, isLoading } = useRequest(getIndexArticlesAPI);
    request({
      type: 'video',
      uuid: route.query.id,
    });

    const getIndexArticles = async (res) => {
      try {
        const formatArticle = {
          ...res.value.result,
          formatPublished: dayjs(res.value.result.published).format('YYYY-MM-DD'),
        };

        articleData.value = formatArticle;
        extraBreadcrumbStore.setExtraBreadcrumb(formatArticle.title);
        const splitUrl = formatArticle.data.video_url.split('/');
        const getVideoId = splitUrl[splitUrl.length - 1];
        const ytEmbedBaseUrl = 'https://www.youtube.com/embed/';
        videoSrc.value = `${ytEmbedBaseUrl}${getVideoId}`;
      } catch (e) {
        console.log('e', e);
      }
    };

    watch(response, () => {
      getIndexArticles(response);
    });

    watch(() => route.query.id, () => {
      request({
        type: 'news',
        uuid: route.query.id,
      });
    });

    return {
      articleData,
      videoSrc,
      isLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/styles/share/pureText.scss';
@import '@/styles/share/article.scss';
.story-title {
  @include font-style($c-main, 35, 500, 3.5px, 51px);
}

.time-type {
  @include flex();

  &__time {
    @include font-style($c-main, 16, 400, 1.6px, 28px);
  }

  &__type {
    position: relative;
    margin-left: 23px;
    @include font-style($c-assist-pink, 16, 400, 1.6px, 28px);

    &::before {
      content: '';
      width: 1px;
      height: 20px;
      @include position(tl, 50%, -12px);
      transform: translateY(-50%);
      display: inline-block;
      background-color: $c-main;
    }
  }
}

.img-box {
  &__img {
    width: 100%;
    max-width: 100%;
  }
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
  margin-bottom: 50px;

  iframe,
  object,
  embed {
    @include position(tl, 0, 0);
    width: 100%;
    height: 100%;
  }
}

@media screen and (min-width: $tablet) {
  .img-box {
    &__img {
      max-width: 763px;
    }
  }
}
</style>
